import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { fetchUserAttributes, fetchAuthSession, updateUserAttributes } from '@aws-amplify/auth';
import { AuthService } from 'app/core/http/services/auth.service';
import { CognitoService } from 'app/core/http/services/cognito.service';
import { LoadingModalComponent } from 'app/pages/loading-modal/loading-modal.component';
import { firstValueFrom } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'google-page-login',
  templateUrl: './google-login.component.html',
  styleUrls: ['./google-login.component.scss'],
})
export class GoogleLoginComponent implements OnInit {
  public successLogin: boolean = false;
  public submitted: boolean = false;
  public form!: FormGroup;

  constructor(
    private cognitoService: CognitoService,
    private auth: AuthService,
    private router: Router,
    private fb: FormBuilder,
    private dialog: MatDialog
  ) {}

  async ngOnInit(): Promise<void> {
    this.form = this.fb.group({
      type: new FormControl(null, [Validators.required]),
    });

    const dialogRef: MatDialogRef<LoadingModalComponent> = this.dialog.open(LoadingModalComponent, {
      disableClose: true,
    });

    try {
      await this.getCurrentUserInfo();
    } catch (error) {
      console.error('Falha ao obter informações do usuário:', error);
    } finally {
      dialogRef.close();
    }
  }

  private async getCurrentUserInfo(): Promise<void> {
    try {
      const session = await fetchAuthSession();
      const { accessToken, idToken } = session.tokens ?? {};
      if (!idToken) {
        console.warn('Nenhum token encontrado');
        return;
      }

      const userTokenId: string = idToken.toString();
      localStorage.setItem('userTokenId', userTokenId);

      const attributes = await fetchUserAttributes();
      const sub = attributes['sub'];
      const type: any = attributes['custom:type'];
      const firstAccess: any = attributes['custom:firstAccess'];
      localStorage.setItem('isFirstAccess', firstAccess);

      const validTypes = ['organization', 'secretary', 'patient', 'practitioner'];
      if (!validTypes.includes(type)) {
        throw new Error(`Tipo de usuário inválido: ${type}`);
      }

      if (firstAccess !== 'false') {
        this.auth.setUser([], type, idToken, sub);
        this.redirectTo('home');
        return;
      }

      const users: any[] = await firstValueFrom(this.cognitoService.getUser(type, sub!).pipe(finalize(() => console.log('OK'))));

      this.auth.setUser(users[0], type, idToken, sub);
      this.submitted = true;
      this.successLogin = true;
      this.redirectTo('home');
    } catch (error) {
      throw error;
    } finally {
    }
  }

  redirectTo(uri: string): void {
    this.router.navigateByUrl(uri).then(() => window.location.reload());
  }

  async completeRegistration(type: string): Promise<void> {
    await this.cognitoService.updateUserType(type);
    await updateUserAttributes({
      userAttributes: {
        'custom:firstAccess': 'true',
      },
    });

    setTimeout(() => {
      location.reload();
    }, 3000);
  }
}